/* app/js/src/components/common/segment/segment-button.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host:not(:last-child) {
  margin-right: 8px;
}
:host {
  width: 32px;
  height: 30px;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}
:host ::ng-deep svg {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  fill: #879baf !important;
}
:host.active {
  border: 1px #e1e6eb solid;
}
:host:hover ::ng-deep svg,
:host.active ::ng-deep svg {
  fill: #a65bfa !important;
}
:host:hover ::ng-deep svg path,
:host.active ::ng-deep svg path {
  stroke: #a65bfa !important;
}
/*# sourceMappingURL=segment-button.component.css.map */
